module.exports = __webpack_public_path__ + "img/font-contrast.2b6d2b4b.svg";